/* Stone Store small enhancements (2026-10-20). Loaded by the hidden
   "stone-store-styles" section; no core theme files are edited.
   1. Menu links: wrap the label text in <span class="ss-u"> so the CSS can
      draw a left-to-right underline under the words only (not the arrow or
      the link's padding).
   2. Product share buttons: add WhatsApp, Copy link and (where the device
      supports it) the phone's own share sheet, which covers Instagram,
      Messages and other apps. */
(function () {
  var MENU_LINKS = '.nav-bar__link, .nav-dropdown__link, .mega-menu__link, .mega-menu__title';

  function wrapMenuLabels(root) {
    root.querySelectorAll(MENU_LINKS).forEach(function (link) {
      if (link.querySelector('.ss-u')) return;
      for (var i = 0; i < link.childNodes.length; i++) {
        var node = link.childNodes[i];
        if (node.nodeType === 3 && node.textContent.trim()) {
          var span = document.createElement('span');
          span.className = 'ss-u';
          span.textContent = node.textContent.trim();
          link.replaceChild(span, node);
          break;
        }
      }
    });
  }

  // Same look as the theme's share icons: a filled 30px circle with the
  // symbol in the card colour.
  var GLYPH = '#fffdf9';
  function circleIcon(inner) {
    return '<svg class="icon" viewBox="0 0 30 30" width="28" height="28" aria-hidden="true" focusable="false">' +
      '<circle cx="15" cy="15" r="15" fill="currentColor"/>' + inner + '</svg>';
  }
  function strokeGlyph(d, width) {
    return '<g transform="translate(8 8) scale(.583)"><path fill="none" stroke="' + GLYPH + '" stroke-width="' + (width || 2.6) +
      '" stroke-linecap="round" stroke-linejoin="round" d="' + d + '"/></g>';
  }
  var ICONS = {
    whatsapp: circleIcon('<g transform="translate(7.2 7.2) scale(.65)"><path fill="' + GLYPH + '" d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.2h.01c5.46 0 9.91-4.45 9.91-9.91A9.850 9.850 0 0 0 12.04 2Zm0 18.15h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.23 8.23 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.18 8.18 0 0 1 2.41 5.830c0 4.54-3.7 8.23-8.24 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.42.08-.16.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48a.92.92 0 0 0-.66.31c-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.47-.29Z"/></g>'),
    link: circleIcon(strokeGlyph('M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71')),
    check: circleIcon(strokeGlyph('M5 12.5l4.5 4.5L19 7.5', 3)),
    share: circleIcon(strokeGlyph('M12 3v12M7.5 7.5 12 3l4.5 4.5M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7'))
  };

  function productUrl() {
    var canonical = document.querySelector('link[rel="canonical"]');
    return canonical ? canonical.href : location.origin + location.pathname;
  }

  function productTitle() {
    var h = document.querySelector('.product-meta__title');
    return h ? h.textContent.trim() : document.title;
  }

  function addShareButtons(root) {
    root.querySelectorAll('.product-meta__share-buttons .social-media__item-list').forEach(function (list) {
      if (list.dataset.ssShare) return;
      list.dataset.ssShare = '1';
      var url = productUrl();
      var title = productTitle();

      var wa = document.createElement('li');
      wa.className = 'social-media__item social-media__item--whatsapp';
      wa.innerHTML = '<a href="https://wa.me/?text=' + encodeURIComponent(title + ' ' + url) +
        '" target="_blank" rel="noopener" aria-label="Share on WhatsApp">' + ICONS.whatsapp + '</a>';
      list.appendChild(wa);

      var copy = document.createElement('li');
      copy.className = 'social-media__item social-media__item--copy';
      copy.innerHTML = '<a href="' + url + '" role="button" aria-label="Copy link" data-ss-copy>' + ICONS.link +
        '<span class="ss-copied" aria-live="polite"></span></a>';
      list.appendChild(copy);

      if (navigator.share) {
        var more = document.createElement('li');
        more.className = 'social-media__item social-media__item--more';
        more.innerHTML = '<a href="' + url + '" role="button" aria-label="More sharing options" data-ss-native>' + ICONS.share + '</a>';
        list.appendChild(more);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var copyLink = event.target.closest('[data-ss-copy]');
    if (copyLink) {
      event.preventDefault();
      var done = function () {
        var note = copyLink.querySelector('.ss-copied');
        copyLink.classList.add('is-copied');
        copyLink.firstElementChild.outerHTML = ICONS.check;
        if (note) note.textContent = 'Link copied';
        setTimeout(function () {
          copyLink.classList.remove('is-copied');
          copyLink.firstElementChild.outerHTML = ICONS.link;
          if (note) note.textContent = '';
        }, 2000);
      };
      // Older browsers (or a blocked clipboard): copy through a hidden text box.
      var fallback = function () {
        var box = document.createElement('textarea');
        box.value = copyLink.href;
        box.setAttribute('readonly', '');
        box.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
        document.body.appendChild(box);
        box.select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) {}
        box.remove();
        if (ok) done();
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(copyLink.href).then(done, fallback);
      } else {
        fallback();
      }
      return;
    }

    var nativeLink = event.target.closest('[data-ss-native]');
    if (nativeLink) {
      event.preventDefault();
      navigator.share({ title: productTitle(), url: nativeLink.href }).catch(function () {});
    }
  });

  // The star rating under the product title links to #product-reviews; give
  // the Judge.me review section that anchor so the click scrolls to it.
  function anchorReviews() {
    if (document.getElementById('product-reviews')) return;
    var widget = document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
    var section = widget && widget.closest('.shopify-section');
    if (!section) return;
    var anchor = document.createElement('span');
    anchor.id = 'product-reviews';
    anchor.style.display = 'block';
    section.insertBefore(anchor, section.firstChild);
  }

  function run(root) {
    wrapMenuLabels(root);
    addShareButtons(root);
    anchorReviews();
  }

  function start() {
    run(document);
    // The product block re-renders when a variant changes; re-add the buttons
    // (at most once per frame, since sliders change the page constantly).
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; run(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
